
import { PropType, defineComponent } from "vue";
export default defineComponent({
  name: "customInput",
  props: {
    modelValue: {
      type: String as PropType<string>,
      required: true,
    },
    inputId: {
      type: String as PropType<string>,
      required: true,
    },
    labelName: { type: String as PropType<string>, required: true },
  },
  computed: {
    isEmpty(): boolean {
      return this.modelValue === "";
    },
  },
  emits: ["update:modelValue", "enterKeyUp"],
  methods: {
    modelValueChange(value: string): void {
      this.$emit("update:modelValue", value);
    },
  },
});
